export default "__VITE_ASSET__c7426f59__"